import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaFileImport, FaVial, FaClipboardList } from "react-icons/fa";
import styles from "../Analysis.module.css";

const AnalysisDashboard = () => {
    const navigate = useNavigate();
    const [statistics, setStatistics] = useState({
        pendingResults: 0,
        inProgressBatches: 0,
        activeWorklists: 0
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadStatistics();
    }, []);

    const loadStatistics = async () => {
        try {
            setLoading(true);
            // TODO: Replace with actual API calls
            // const accessToken = await getBackendAccessToken();
            // const data = await analysisService.getStatistics(accessToken);
            
            // Placeholder data
            setStatistics({
                pendingResults: 24,
                inProgressBatches: 6,
                activeWorklists: 3
            });
        } catch (error) {
            console.error('Failed to load analysis statistics:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.dashboard}>
            {/* Statistics Section */}
            <div className={styles.statsGrid}>
                <div className={styles.statCard}>
                    <h3>Pending Results</h3>
                    <div className={styles.statNumber}>{statistics.pendingResults}</div>
                    <div className={styles.statLabel}>Awaiting Analysis</div>
                </div>
                <div className={styles.statCard}>
                    <h3>In Progress Batches</h3>
                    <div className={styles.statNumber}>{statistics.inProgressBatches}</div>
                    <div className={styles.statLabel}>Currently Running</div>
                </div>
                <div className={styles.statCard}>
                    <h3>Active Worklists</h3>
                    <div className={styles.statNumber}>{statistics.activeWorklists}</div>
                    <div className={styles.statLabel}>Ready for Processing</div>
                </div>
            </div>

            {/* Analysis Actions */}
            <div className={styles.quickActions}>
                <h3>Analysis Actions</h3>
                <div className={styles.actionGrid}>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/lab/manual-import')}
                    >
                        <span className={`${styles.actionIcon} ${styles.manualImport}`}><FaFileImport /></span>
                        <span>Manual Import</span>
                    </button>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/lab/qc-batches')}
                    >
                        <span className={`${styles.actionIcon} ${styles.qcBatches}`}><FaVial /></span>
                        <span>QC Batches</span>
                    </button>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/lab/worklists')}
                    >
                        <span className={`${styles.actionIcon} ${styles.worklists}`}><FaClipboardList /></span>
                        <span>Worklists</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AnalysisDashboard;
